import React          from 'react';
import PropTypes      from 'prop-types'
import RadioComponent from 'pu-react/components/base/RadioComponent';
import HiddenInput    from 'pu-react/components/base/HiddenInput';

import { tabRout as tabToutTooltip, scoring as scoringTooltip } from 'pu-data/Tooltips';

const TabRoutScoring = props => (
  <div>
    <HiddenInput
      name="tab_rout"
      value={props.tab_rout}
      groupName={props.groupName}/>
    <HiddenInput
      name="scoring"
      value={props.scoring}
      groupName={props.groupName}/>
  </div>
);

TabRoutScoring.defaultProps = {
  type: 'checkbox',
  tab_rout: '',
  scoring: '',
};

TabRoutScoring.propTypes = {
  parameters: PropTypes.object.isRequired,
}

export default TabRoutScoring;
